import React from "react"
import { Field, FieldRenderProps } from "react-final-form"
import InfoBox from "../boxes/InfoBox"
import Select, { OptionProps } from "../controls/Select"
import SubmitError from "./SubmitError"
import { fieldClass, fieldStyle, identity, StyledProps } from "../../utils/form";

interface SelectFieldProps extends StyledProps {
  className?: string;
  hasHeader?: boolean;
  hasLabel?: boolean;
  disabled?: boolean;
  disabledWithValue?: null | number | string;
  frequentlyChosenOptions?: OptionProps[];
  id?: string;
  i18nKey?: string;
  i18nTip?: string
  name: string;
  options: OptionProps[];
  small?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = (props: SelectFieldProps) => {
  const disabled = props.disabled || !!props.disabledWithValue
  return (
    <Field
      {...props}
      parse={identity}
      render={(renderProps: FieldRenderProps<number | string>): React.ReactNode => {
        const { className, frequentlyChosenOptions, i18nKey, i18nTip, id, meta, options, small } = renderProps
        const input = props.disabledWithValue ? {value: props.disabledWithValue} : renderProps.input
        return (
          <div className={fieldClass(className, !!meta.submitError)} style={fieldStyle(props)}>
            <Select
              disabled={disabled}
              frequentlyChosenOptions={frequentlyChosenOptions}
              hasHeader={props.hasHeader}
              hasLabel={props.hasLabel}
              i18nKey={i18nKey as string | undefined}
              input={{...input, id}}
              options={options as OptionProps[]}
              small={small}
              withError={!!meta.submitError}
            />
            <SubmitError errors={meta.submitError}/>
            {i18nTip && <InfoBox i18nKey={i18nTip}/>}
          </div>
        )
      }}
    />
  )
}

export default SelectField
